import React, { useEffect, useState } from 'react'
import GradientButton from 'components/Button/GradientButton'
import OutlineButton from 'components/Button/OutlineButton'
import styles from './index.module.scss'

const ArtworkTab = props => {
  const { artworkType, setArtworkType } = props

  return (
    <div className={styles.container}>
      <div className="min-w-[66px]">
        {artworkType === 'all' ? (
          <GradientButton
            label="All"
            backgroundColor={'var(--bg-FFF-202427)'}
            width={66}
            height={43}
            onClick={() => {}}
          />
        ) : (
          <OutlineButton
            label="All"
            backgroundColor={'rgba(var(--main-bg-color-rgb), 0.1)'}
            fontFamily="Jost-Regular"
            color="var(--bg-A5A5A5-606060)"
            borderColor="transparent"
            width={66}
            height={43}
            onClick={() => {
              setArtworkType('all')
            }}
          />
        )}
      </div>

      <div className="min-w-[122px]">
        {artworkType === 'listed' ? (
          <GradientButton
            label="Quick Buy"
            backgroundColor={'var(--bg-FFF-202427)'}
            fullWidth
            height={43}
            onClick={() => {}}
          />
        ) : (
          <OutlineButton
            label="Quick Buy"
            backgroundColor={'rgba(var(--main-bg-color-rgb), 0.1)'}
            fontFamily="Jost-Regular"
            color="var(--bg-A5A5A5-606060)"
            borderColor="transparent"
            fullWidth
            height={43}
            onClick={() => {
              setArtworkType('listed')
            }}
          />
        )}
      </div>

      <div className="min-w-[146px]">
        {artworkType === 'auction' ? (
          <GradientButton
            label="Live Auctions"
            backgroundColor={'var(--bg-FFF-202427)'}
            fullWidth
            height={43}
            onClick={() => {}}
          />
        ) : (
          <OutlineButton
            label="Live Auctions"
            backgroundColor={'rgba(var(--main-bg-color-rgb), 0.1)'}
            fontFamily="Jost-Regular"
            color="var(--bg-A5A5A5-606060)"
            borderColor="transparent"
            fullWidth
            height={43}
            onClick={() => {
              setArtworkType('auction')
            }}
          />
        )}
      </div>

      <div className="min-w-[140px]">
        {artworkType === 'edition' ? (
          <GradientButton
            label="Live Edition"
            backgroundColor={'var(--bg-FFF-202427)'}
            fullWidth
            height={43}
            onClick={() => {}}
          />
        ) : (
          <OutlineButton
            label="Live Edition"
            backgroundColor={'rgba(var(--main-bg-color-rgb), 0.1)'}
            fontFamily="Jost-Regular"
            color="var(--bg-A5A5A5-606060)"
            borderColor="transparent"
            fullWidth
            height={43}
            onClick={() => {
              setArtworkType('edition')
            }}
          />
        )}
      </div>
    </div>
  )
}

export default ArtworkTab
